export default {"src":"/_next/static/media/google-play.b43bb643.svg","height":191,"width":646,"blurWidth":0,"blurHeight":0};